export default __webpack_public_path__ + "static/media/hackersIcon.b3424a56.svg";